import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "29",
  fill: "none",
  viewBox: "0 0 24 29"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 0c.876 0 1.742.176 2.551.517.81.34 1.544.84 2.163 1.47.62.63 1.11 1.379 1.445 2.202s.508 1.706.508 2.597V9.5h4c.353 0 .692.143.942.398.25.254.391.6.391.96v16.285c0 .36-.14.705-.39.96-.25.254-.59.397-.943.397H1.333c-.353 0-.692-.143-.942-.398a1.37 1.37 0 0 1-.391-.96V10.858c0-.36.14-.705.39-.96.25-.254.59-.397.943-.397h4V6.786c0-1.8.703-3.526 1.953-4.799A6.6 6.6 0 0 1 12 0m6.667 13.571H16v1.358c0 .345.13.678.364.93a1.319 1.319 0 0 0 1.825.11c.26-.223.428-.538.468-.882l.01-.158zM8 13.571H5.333v1.358c0 .345.13.678.364.93a1.319 1.319 0 0 0 1.825.11c.261-.223.429-.538.469-.882L8 14.93zm4-10.857c-1.02 0-2.002.397-2.744 1.11a4.1 4.1 0 0 0-1.25 2.723L8 6.786V9.5h8V6.786c0-1.039-.39-2.038-1.09-2.794a3.97 3.97 0 0 0-2.675-1.27z"
    }, null, -1)
  ])))
}
export default { render: render }